import { render, staticRenderFns } from "./TasksCardAdd.vue?vue&type=template&id=874bf8a6&scoped=true"
import script from "./TasksCardAdd.vue?vue&type=script&lang=js"
export * from "./TasksCardAdd.vue?vue&type=script&lang=js"
import style0 from "./TasksCardAdd.vue?vue&type=style&index=0&id=874bf8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874bf8a6",
  null
  
)

export default component.exports